import { administratorRoles } from "../../config/roles";
import { RecordDefinition } from "../recordDefinition.types";
import { competitionPageConfig } from "./competitionPageConfig";

export const competitionRecordDefinition: RecordDefinition = {
  path: "/competition",
  entityName: "dwcompetition",
  listRoute: "/competitions",
  backTitle: "Back to competitions",
  allowedRoles: administratorRoles,
  config: competitionPageConfig,
  // The warehouse holds this record, and the view resolver never sees it.
  authorable: false,
  identity: {
    titleFields: ["name"],
    fallbackTitle: "Competition",
    newRecordTitle: "New Competition",
  },
};
